export enum Role {
  Student = 'student',
  Teacher = 'teacher',
  Admin = 'admin',
}

export interface AuthResponse {
  user: CurrentUser;
}

export interface CurrentUser {
  userId: string;
  role: Role;
  userName: string;
  email: string;
  profileId: string;
  displayName: string;
  profilePictureUrl?: string;
}

export interface User {
  id: string;
  userName: string;
  email: string;
  role: Role;
  createdAt: string;
  updatedAt: string;
}
